import { Head, Link, usePage } from '@inertiajs/react'
import MainLayout from '../../components/layout/MainLayout'

export default function MentionsLegales() {
  const { lastUpdate } = usePage().props

  return (
    <MainLayout>
      <Head title="Mentions légales — SmartImmo" />

      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <header className="mb-10">
          <h1 className="text-4xl font-bold text-gray-900 mb-3">Mentions légales</h1>
          <p className="text-sm text-gray-500">Dernière mise à jour : {lastUpdate}</p>
        </header>

        <nav aria-label="Sommaire" className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-12">
          <h2 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">Sommaire</h2>
          <ol className="space-y-2 text-sm text-gray-700 list-decimal list-inside">
            <li><a href="#editeur" className="hover:text-primary-600">Éditeur du site</a></li>
            <li><a href="#directeur" className="hover:text-primary-600">Directeur de la publication</a></li>
            <li><a href="#hebergeur" className="hover:text-primary-600">Hébergement</a></li>
            <li><a href="#propriete" className="hover:text-primary-600">Propriété intellectuelle</a></li>
            <li><a href="#responsabilite" className="hover:text-primary-600">Limitation de responsabilité</a></li>
            <li><a href="#donnees" className="hover:text-primary-600">Données personnelles et cookies</a></li>
            <li><a href="#droit" className="hover:text-primary-600">Droit applicable et juridiction</a></li>
            <li><a href="#contact" className="hover:text-primary-600">Contact</a></li>
          </ol>
        </nav>

        <article className="prose prose-gray max-w-none">
          <section id="editeur" className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Éditeur du site</h2>
            <p className="text-gray-700 mb-2">
              Le site <strong>smartimmo.sinoia.fr</strong> est édité par :
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded p-4 my-4 text-sm text-gray-800 leading-relaxed">
              <p><strong>PLUGANDWORK</strong> (nom commercial : Sinoia)</p>
              <p>Société par actions simplifiée à associé unique (SASU)</p>
              <p>Capital social : 30 864 €</p>
              <p>SIREN : 439 603 689</p>
              <p>RCS Nîmes</p>
              <p>Siège social : 132 vieille route d'Anduze, 30100 Alès, France</p>
              <p>Email : contact@sinoia.fr</p>
            </div>
            <p className="text-gray-700">
              SmartImmo est une marque exploitée par PLUGANDWORK pour son offre SaaS de génération
              de leads immobiliers qualifiés par intelligence artificielle.
            </p>
          </section>

          <section id="directeur" className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Directeur de la publication</h2>
            <p className="text-gray-700">
              Le directeur de la publication est le représentant légal de PLUGANDWORK.
              Toute demande peut être adressée à l'adresse postale du siège social ou par
              courriel à <a href="mailto:contact@sinoia.fr" className="text-primary-600 hover:underline">contact@sinoia.fr</a>.
            </p>
          </section>

          <section id="hebergeur" className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Hébergement</h2>
            <p className="text-gray-700 mb-2">Le site est hébergé par :</p>
            <div className="bg-gray-50 border border-gray-200 rounded p-4 my-4 text-sm text-gray-800 leading-relaxed">
              <p><strong>OVH SAS</strong></p>
              <p>2 rue Kellermann, 59100 Roubaix, France</p>
              <p>RCS Lille Métropole 424 761 419 00045</p>
              <p>Téléphone : 1007 (depuis la France)</p>
              <p>Site : <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline">www.ovhcloud.com</a></p>
            </div>
          </section>

          <section id="propriete" className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Propriété intellectuelle</h2>
            <p className="text-gray-700 mb-3">
              L'ensemble des éléments composant le site smartimmo.sinoia.fr (structure, textes,
              images, graphismes, logos, vidéos, icônes, code source, base de données) sont la
              propriété exclusive de PLUGANDWORK ou de ses partenaires, et sont protégés par le
              droit français et international relatif à la propriété intellectuelle.
            </p>
            <p className="text-gray-700 mb-3">
              Toute reproduction, représentation, modification, publication, transmission, ou
              exploitation totale ou partielle du site ou de son contenu, par quelque procédé
              que ce soit, sans l'autorisation préalable écrite de PLUGANDWORK, est strictement
              interdite et constituerait une contrefaçon sanctionnée par les articles L.335-2
              et suivants du Code de la propriété intellectuelle.
            </p>
            <p className="text-gray-700">
              Les marques « SmartImmo » et « Sinoia », ainsi que tous les logos associés, sont
              des marques appartenant à PLUGANDWORK. Toute reproduction non autorisée est
              prohibée.
            </p>
          </section>

          <section id="responsabilite" className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Limitation de responsabilité</h2>
            <p className="text-gray-700 mb-3">
              PLUGANDWORK met tout en œuvre pour assurer l'exactitude et la mise à jour des
              informations diffusées sur le site, mais ne peut garantir l'absence d'erreur ou
              d'omission. Les informations contenues sur le site sont fournies à titre indicatif
              et n'engagent pas la responsabilité de PLUGANDWORK.
            </p>
            <p className="text-gray-700 mb-3">
              L'utilisateur reconnaît utiliser le site sous sa seule responsabilité. PLUGANDWORK
              ne pourra être tenue responsable des dommages directs ou indirects résultant de
              l'utilisation du site, de l'indisponibilité du service, de la présence de virus
              ou de toute intrusion sur les systèmes informatiques de l'utilisateur.
            </p>
            <p className="text-gray-700">
              Le site peut contenir des liens vers des sites tiers. PLUGANDWORK n'exerce aucun
              contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>

          <section id="donnees" className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Données personnelles et cookies</h2>
            <p className="text-gray-700">
              Le traitement des données personnelles collectées sur le site est détaillé dans la{' '}
              <Link href="/politique-confidentialite" className="text-primary-600 hover:underline">
                politique de confidentialité
              </Link>
              . Les modalités d'utilisation des cookies sont décrites dans la{' '}
              <Link href="/politique-cookies" className="text-primary-600 hover:underline">
                politique cookies
              </Link>
              .
            </p>
          </section>

          <section id="droit" className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Droit applicable et juridiction</h2>
            <p className="text-gray-700">
              Les présentes mentions légales sont régies par le droit français. En cas de litige
              relatif à l'utilisation du site, et à défaut de résolution amiable, les tribunaux
              français seront seuls compétents, sous réserve des dispositions légales impératives
              en faveur des consommateurs.
            </p>
          </section>

          <section id="contact" className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Contact</h2>
            <p className="text-gray-700">
              Pour toute question relative aux présentes mentions légales, vous pouvez nous
              contacter par courriel à <a href="mailto:contact@sinoia.fr" className="text-primary-600 hover:underline">contact@sinoia.fr</a>{' '}
              ou par courrier à l'adresse du siège social.
            </p>
          </section>
        </article>
      </div>
    </MainLayout>
  )
}
